import { useState } from 'react';

const useRemoveButton = () => {
    const [isEnabled, setIsEnabled] = useState<boolean>(true);

    const hide = (): void => setIsEnabled(false);

    return { isEnabled, hide };
};

export default useRemoveButton;
